import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledRadioGroup,
  StyledFormControl,
  StyledFormLabel,
  StyledFormControlLabel,
  StyledRadio,
  LPText,
} from './styles';

const RadioBtn = ({
  label, name, value, onChange, items, errors,
}) => (
  <StyledFormControl component="fieldset">
    <StyledFormLabel focused={false} component="legend">
      {label}
    </StyledFormLabel>
    <StyledRadioGroup aria-label={label} name={name} value={value} onChange={onChange}>
      {items.map(({ label: itemLabel, value: itemValue }) => (
        <StyledFormControlLabel
          bgColor={value === itemValue ? 'var(--brand-color)' : 'inherit'}
          color={value === itemValue ? 'var(--text-light-color)' : 'var(--text-color)'}
          key={itemValue}
          value={itemValue}
          control={<StyledRadio />}
          label={itemLabel}
        />
      ))}
    </StyledRadioGroup>
    {errors.map((error) => (
      <LPText key={error} small padded error m05>
        {error}
      </LPText>
    ))}
  </StyledFormControl>
);

RadioBtn.defaultProps = {
  label: '',
  value: '',
  items: [],
  errors: [],
};

RadioBtn.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape()),
  errors: PropTypes.arrayOf(PropTypes.string),
};

export default RadioBtn;
